export default __webpack_public_path__ + "static/media/infolot.60e4e777.jpg";